<template>
  <router-link 
    v-if="showAlways || hasPermissionForRoute" 
    :to="to" 
    :class="{'is-disabled': !hasPermissionForRoute && showAlways}" 
    :aria-disabled="!hasPermissionForRoute && showAlways"
    v-bind="$attrs"
  >
    <slot></slot>
  </router-link>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { canAccessRoute } from '@/utils/permissions'

export default {
  name: 'PermissionRouterLink',
  inheritAttrs: false,
  props: {
    // The route to link to, same as router-link 'to' prop
    to: {
      type: [String, Object],
      required: true
    },
    // Whether to show the link always, even if user doesn't have permission
    // When true, link will be shown but disabled (non-clickable) if no permission
    showAlways: {
      type: Boolean,
      default: false
    },
    // Explicitly specify a route name if not using standard route resolution
    routeName: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const router = useRouter()

    const resolvedRoute = computed(() => {
      if (props.routeName) {
        // If route name is explicitly provided, use it
        return router.resolve({ name: props.routeName })
      }

      // Otherwise resolve from the 'to' prop
      return router.resolve(props.to)
    })

    const hasPermissionForRoute = computed(() => {
      return canAccessRoute(resolvedRoute.value)
    })

    return {
      hasPermissionForRoute
    }
  }
}
</script>

<style scoped>
.is-disabled {
  opacity: 0.65;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
